import {SET,SET_LOADING} from './Actions';

const initialState = {
  collections:null,
  current_collection:'رسانه',
  current_search:'',
  collectionLoading:false,
  list:null,
  current_page:1,
  last_page:1,
  per_page:20,
  loading:false,
  showGallery:false,
  handleSelectFile:null,
};

export default (state = initialState, action) => {
  switch (action.type)
   {
    case SET:
      return {
        ...state,
        ...action.payload
      }
    case SET_LOADING:
      return {
        ...state,
        loading:action.payload
      }
   

    default:
      return state;
  }
};
